import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseForecastingProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseForecasting: React.FunctionComponent<React.PropsWithChildren<NewReleaseForecastingProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseForecastingProps) => (
    <SVGBase viewBox="0 0 49.95 50" height={height} width={width} title={title} fill={fill} {...rest}>
        <path fill="#99ebc2" d="M.28,33.89a.76.76,0,0,0-.16,1l1.19,1.8a.73.73,0,0,0,1,.24l5.22-3L5,30.12Z" />
        <path
            fill="#40d98c"
            d="M47.33,4.41c-1.95-3-4.24-4.89-5.11-4.3L12.06,22.43l.66,1-8,6.35.21.33L7.49,34l.21.33,1.72-1A4.36,4.36,0,0,1,17,28.94a4,4,0,0,1,.46,1.14L49.29,10.86C50.16,10.26,49.28,7.38,47.33,4.41Z"
        />
        <path
            fill="#99ebc2"
            d="M11,27.36A4.35,4.35,0,0,0,9.42,33.3v0A4.33,4.33,0,0,0,11,34.91V46.56a4,4,0,0,0-1.79,3.31V50h7.93v-.13a4,4,0,0,0-1.77-3.31V34.9a4.34,4.34,0,0,0,2-4.82A4,4,0,0,0,17,28.94,4.35,4.35,0,0,0,11,27.36Z"
        />
        <rect fill="#40d98c" x="42.53" y="23.89" width="7.42" height="26.1" rx="0.76" />
        <rect fill="#40d98c" x="32.03" y="31.58" width="7.42" height="18.41" rx="0.76" />
        <rect fill="#40d98c" x="21.54" y="37.59" width="7.42" height="12.4" rx="0.76" />
    </SVGBase>
);

export default NewReleaseForecasting;
